

import React from 'react';
import { Button, Modal, ModalHeader,Alert, ModalBody, ModalFooter } from 'reactstrap';
import { Form, Field, reduxForm } from 'redux-form';
import { FormGroup, Label } from 'reactstrap';
import { ReduxInput } from '../../components/ReduxInput';
import { isRequired, passwordVerify } from '../../components/ReduxInput/Validators';
import Waitable from '../Waitable';

class ChangePasswordForm extends React.Component {

  render() {
    let { handleSubmit, errorText } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          {errorText ? <Alert color="danger">{errorText}</Alert> : null}
          <FormGroup>
            <Label htmlFor="email">Current Password</Label>
            <Field
              type="password"
              name="currentPassword"
              placeholder="Password"
              id="password"
              component={ReduxInput}
              validate={[isRequired]}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="email">New Password</Label>
            <Field
              type="password"
              name="password"
              placeholder="Password"
              id="password"
              component={ReduxInput}
              validate={[isRequired]}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="email">Confirm New Password</Label>
            <Field
              type="password" name="confirm" placeholder="Confirm password"
              component={ReduxInput}
              validate={[isRequired, passwordVerify]}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <FormGroup>
            <Button id="sign-in-button" type="submit" color="primary">
              Change Password
            </Button>
          </FormGroup>
        </ModalFooter>
      </Form>
    );

  }
}

const ReduxChangePasswordForm = reduxForm({
  form: 'ChangePasswordForm', // a unique identifier for this form
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true
})(ChangePasswordForm);

export default class ChangePasswordModal extends React.Component {

  constructor(props) {
    super(props);


  }


  render() {
    let { isOpen, toggle, className, onSubmit, passwordUpdateSelfData } = this.props;

    let errorText = passwordUpdateSelfData.get("error");
    if(errorText){
      errorText = errorText.message;
    }

    return (
      <Modal isOpen={isOpen} toggle={toggle} className={'modal-primary ' + className}>
        <Waitable entities={[passwordUpdateSelfData]}>
          <ModalHeader toggle={toggle}> Change Password </ModalHeader>
          <ReduxChangePasswordForm errorText={errorText} onSubmit={onSubmit} isOpen={isOpen} toggle={toggle} className={className} />
        </Waitable >
      </Modal >
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ChangePasswordModal/ChangePasswordModal.js